// Dummy data for the Mechanical Oilseal Company website

export const categories = [
  {
    id: 1,
    name: "Radial Seals",
    description: "High-performance radial seals for various applications",
    image: "/Dummy Image.PNG"
  },
  {
    id: 2,
    name: "Axial Seals",
    description: "Durable axial seals for industrial machinery",
    image: "/Dummy Image.PNG"
  },
  // {
  //   id: 3,
  //   name: "Hydraulic Seals",
  //   description: "Specialized hydraulic seals for heavy-duty applications",
  //   image: "/Dummy Image.PNG"
  // },
  {
    id: 4,
    name: "Rotary Seals",
    description: "Precision rotary seals for rotating equipment",
    image: "/Dummy Image.PNG"
  },
  {
    id: 5,
    name: "O-Rings",
    description: "Standard and custom O-rings for various industries",
    image: "/Dummy Image.PNG"
  },
  // {
  //   id: 6,
  //   name: "Gaskets",
  //   description: "High-quality gaskets for sealing applications",
  //   image: "/Dummy Image.PNG"
  // }
];

export const products = [
  {
    id: 1,
    name: "Premium Radial Seal RS-100",
    category: "Radial Seals",
    categoryId: 1,
    description: "High-performance radial seal designed for extreme conditions",
    image: "/Dummy Image.PNG",
    price: "$45.99",
    specifications: {
      material: "Nitrile Rubber",
      temperature: "-40°C to +120°C",
      pressure: "Up to 10 bar",
      diameter: "25mm - 200mm"
    },
    features: [
      "Excellent wear resistance",
      "High temperature stability",
      "Chemical resistance",
      "Long service life"
    ]
  },
  {
    id: 2,
    name: "Heavy-Duty Axial Seal AS-200",
    category: "Axial Seals",
    categoryId: 2,
    description: "Industrial-grade axial seal for heavy machinery",
    image: "/Dummy Image.PNG",
    price: "$67.50",
    specifications: {
      material: "Fluoroelastomer",
      temperature: "-20°C to +200°C",
      pressure: "Up to 15 bar",
      diameter: "50mm - 300mm"
    },
    features: [
      "Superior chemical resistance",
      "High pressure capability",
      "Low friction coefficient",
      "Easy installation"
    ]
  },
  // {
  //   id: 3,
  //   name: "Hydraulic Seal HS-300",
  //   category: "Hydraulic Seals",
  //   categoryId: 3,
  //   description: "Specialized seal for hydraulic systems",
  //   image: "/Dummy Image.PNG",
  //   price: "$89.99",
  //   specifications: {
  //     material: "Polyurethane",
  //     temperature: "-30°C to +100°C",
  //     pressure: "Up to 25 bar",
  //     diameter: "30mm - 150mm"
  //   },
  //   features: [
  //     "High pressure resistance",
  //     "Excellent sealing performance",
  //     "Durable construction",
  //     "Wide temperature range"
  //   ]
  // },
  {
    id: 4,
    name: "Precision Rotary Seal RS-400",
    category: "Rotary Seals",
    categoryId: 4,
    description: "Precision-engineered rotary seal for rotating equipment",
    image: "/Dummy Image.PNG",
    price: "$125.00",
    specifications: {
      material: "Silicone Rubber",
      temperature: "-60°C to +200°C",
      pressure: "Up to 5 bar",
      diameter: "20mm - 100mm"
    },
    features: [
      "Ultra-low friction",
      "High-speed capability",
      "Temperature stability",
      "Precision manufacturing"
    ]
  },
  {
    id: 5,
    name: "Standard O-Ring OR-500",
    category: "O-Rings",
    categoryId: 5,
    description: "Standard O-ring for general sealing applications",
    image: "/Dummy Image.PNG",
    price: "$12.99",
    specifications: {
      material: "NBR (Nitrile)",
      temperature: "-30°C to +100°C",
      pressure: "Up to 8 bar",
      diameter: "5mm - 50mm"
    },
    features: [
      "Cost-effective solution",
      "Good general purpose sealing",
      "Wide availability",
      "Easy to install"
    ]
  },
  // {
  //   id: 6,
  //   name: "Industrial Gasket G-600",
  //   category: "Gaskets",
  //   categoryId: 6,
  //   description: "Heavy-duty gasket for industrial applications",
  //   image: "/Dummy Image.PNG",
  //   price: "$34.99",
  //   specifications: {
  //     material: "Compressed Fiber",
  //     temperature: "-40°C to +150°C",
  //     pressure: "Up to 20 bar",
  //     diameter: "Custom sizes available"
  //   },
  //   features: [
  //     "Excellent compression recovery",
  //     "Chemical resistance",
  //     "Custom sizing available",
  //     "Long-lasting performance"
  //   ]
  // }
];

export const companyInfo = {
  name: "Mahatva Engineering",
  tagline: "Precision Sealing Solutions for Industry",
  description: "With over 10+ years of experience in the sealing industry, Mahatva Engineering has been providing high-quality sealing solutions to industries worldwide. Our commitment to excellence and innovation has made us a trusted partner for businesses seeking reliable sealing products.",
  address: "PRANAVI ESTATE, MHATRE NAGAR, BEHIND RELIANCE PETROL PUMP, KALYAN-BHIWANDI ROAD, KON GOAN, BHIWANDI, MAHARASHTRA, PIN CODE: 421311",
  phone: "9967205923",
  email: "mhtv.engineering1@gmail.com",
  email2: "info@mahatvaengieneering.com",
  founded: "2025",
  employees: "150+",
  countries: "25+"
};

export const teamMembers = [
  {
    id: 1,
    name: "John Smith",
    position: "CEO & Founder",
    image: "/Dummy Image.PNG"
  },
  {
    id: 2,
    name: "Sarah Johnson",
    position: "Engineering Director",
    image: "/Dummy Image.PNG"
  },
  {
    id: 3,
    name: "Mike Chen",
    position: "Quality Manager",
    image: "/Dummy Image.PNG"
  },
  {
    id: 4,
    name: "Lisa Rodriguez",
    position: "Sales Director",
    image: "/Dummy Image.PNG"
  }
];
